<div class="terms-conditions">
  <div
    class="terms-conditions__select-country-container"
    *ngIf="termsAndConditionsLanguages$ | async as termsAndConditionsLanguages"
    [ngClass]="{ 'terms-conditions__select-country-container--rtl': dir === 'rtl' }"
  >
    <lx-dropdown-country
      [options]="termsAndConditionsLanguages"
      [optionLabel]="'name'"
      [optionValue]="'code'"
      [placeholder]="'Select a Country'"
      [pleaseSelect]="'— Please select —'"
      [selectedValue]="selectedLanguage"
      (buttonClick)="loadTermsAndConditionsForSelectedLanguage($event)"
    ></lx-dropdown-country>
  </div>
  <div [innerHtml]="sanitizedTermsOfConditionContent$ | async" [dir]="dir"></div>
</div>
<lx-loading-spinner
  [message]="loadingInfo().message"
  [loading]="loadingInfo().loading"
  shadingColor="rgba(0,0,0,0.5)"
  [positionRelative]="false"
></lx-loading-spinner>
